<template>
    <div>
        <div class="pt-0 lg:pt-3 border-b border-a-brown-d7c7b8 text-a-brown-502314">
            <div class="flex pb-2 text-14 lg:text-16">
                <div>{{lbl.shoppingcart.subtotal}}</div>
                <div class="mr-0 ml-auto">{{FilterNumberFormat(PlaceOrderStore.state.placeOrder.subtotal)}} {{lbl.shoppingcart.baht}}</div>
            </div>
            <div class="flex pb-2 text-14 lg:text-16" v-if="delivery.deliveryMethod  == 'Delivery'">
                <div>{{lbl.shoppingcart.delivery_fee}}</div>
                <div class="mr-0 ml-auto" v-if="isLoadedDeliveryFee">{{FilterNumberFormat(ShippingStore.state.shipping.shippingPrice)}} {{lbl.shoppingcart.baht}}</div>
                <div class="mr-0 ml-auto" v-else>{{lbl.shoppingcart.calculating}}</div>
            </div>
            <div class="flex pb-2 text-14 lg:text-16">
                <div>{{lbl.shoppingcart.discount}}</div>
                <div class="mr-0 ml-auto" >{{FilterNumberFormat(discount)}} {{lbl.shoppingcart.baht}}</div>
            </div>
            <div class="flex pb-3 font-bold lg:text-18">
                <div class="">{{lbl.shoppingcart.total}}</div>
                <img class="mr-2 ml-auto -mt-2" src="@/assets/shopping_cart/best-price.svg"/>
                <div class="mr-0 ml-0">{{FilterNumberFormat(PlaceOrderStore.state.placeOrder.total)}} {{lbl.shoppingcart.baht}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import LocaleMixin from '@/mixin/LocaleMixin.js';
import DeliveryMixin from '@/mixin/DeliveryMixin.js'
export default {
    name: "CartSummary",
    mixins: [LocaleMixin,DeliveryMixin],
    inject: ['PlaceOrderStore','ShippingStore'],
    data: function() {
        return {
            isLoadedDeliveryFee: false,
        }
    },
    computed: {
        discount: function () {
            if (this.PlaceOrderStore.state.placeOrder.coupon) {
                if (this.PlaceOrderStore.state.placeOrder.coupon.type == "discount_to") { 
                    if (this.ShippingStore.state.shipping.shippingPrice < this.PlaceOrderStore.state.placeOrder.coupon.pricePerUnit) {
                        return this.ShippingStore.state.shipping.shippingPrice;
                    } else {
                        return this.ShippingStore.state.shipping.shippingPrice - this.PlaceOrderStore.state.placeOrder.coupon.pricePerUnit;
                    }      
                } else {
                    if (this.PlaceOrderStore.state.placeOrder.coupon.codeType == "user") {
                        if (this.PlaceOrderStore.state.placeOrder.subtotal < this.PlaceOrderStore.state.placeOrder.coupon.pricePerUnit) {
                            return this.PlaceOrderStore.state.placeOrder.subtotal;
                        } else {
                            return this.PlaceOrderStore.state.placeOrder.coupon.pricePerUnit;
                        }
                    } else {
                        if (this.ShippingStore.state.shipping.shippingPrice < this.PlaceOrderStore.state.placeOrder.coupon.pricePerUnit) {
                            return this.ShippingStore.state.shipping.shippingPrice;
                        } else {
                            return this.PlaceOrderStore.state.placeOrder.coupon.pricePerUnit;
                        }
                    }
                }
                
            } else {
                return 0;
            }
        },
    },
    created: function() {
        
    },
    methods: {
        processDeliveryFee: function() {
            this.isLoadedDeliveryFee = false;
        },
        updateDeliveryFee: function() {
            this.isLoadedDeliveryFee = true;
        },
    }
}
</script>

<style>

</style>